import "./base.css";
import React from "react";
import { createRoot } from "react-dom/client";
import OneSignal from "react-onesignal";
import App from "./app.tsx";
import env from "./env.config.ts";
import { getCurrentLocale } from "./stores/locale.ts";

const root = document.getElementById("root");

// This fires once, at OneSignal.init() time, before the app (and i18next) has
// mounted - too early to pull from the i18n resource bundle, so the two
// variants are inlined directly against the persisted/detected locale.
const WELCOME_NOTIFICATION_MESSAGE =
	getCurrentLocale() === "zh-CN" ? "感谢您的订阅！" : "Thanks for subscribing!";

OneSignal.init({
	appId: env.oneSignalAppId,
	safari_web_id: env.oneSignalSafariId,
	autoResubscribe: true,
	notifyButton: {
		enable: false,
	},
	welcomeNotification: {
		title: "HEMI Teams",
		message: WELCOME_NOTIFICATION_MESSAGE,
	},
	path: "/dashboard/",
	serviceWorkerParam: { scope: "/dashboard/" },
	serviceWorkerPath: "OneSignalSDKWorker.js",
	serviceWorkerUpdaterPath: "OneSignalSDKUpdaterWorker.js",
	notificationClickHandlerMatch: "origin",
	notificationClickHandlerAction: "focus",
});

if (root && !root?.innerHTML) {
	createRoot(root).render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
	);
}
